<div class="date-input-wrapper" [class.invalid]="dueDate && dueDate < actualDate">
    <input #date="ngModel" matInput [matDatepicker]="picker" placeholder="mm/dd/yyyy" name="date" [(ngModel)]="dueDate"
        (ngModelChange)="sendDateToParent()" required/>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    @if(date.touched){
        @if (dueDate != null) {
            @if(dueDate < actualDate){ 
                <span class="warning-date">Date must be in the future!</span>
            }
        } @else if (dueDate === null) {
            <span class="warning-date">Invalid date. Correct: MM/DD/YYYY.</span>
        }
    }
    
</div>